<section class="spacer-pt-space spacer-pb-space">
    <div class="container">
        <div class="text-center">
            <div class="intro-text">
                <h1 class="heading-primary-8xl mb-0">We can't find the page you're looking fors.</h1>
                <div class="editor-content">
                    <p>Unfortunately, the page does not exist. Please try again after some time.</p>
                </div>
            </div>
            <a [routerLink]="'/'" class="button button-orange" title="Go To Home">
                Go To Home
            </a>
        </div>
    </div>
</section>
